import { useLocation, useNavigate } from "react-router-dom";
import qs from "qs";
import Header from "../components/header";
import { SmbMain } from "../components/styles/Smb.styled";
import { useEffect, useRef } from "react";
import AssistantModal from "../components/smb/AssistantModal";
// import { toast } from "react-toastify";
import { showCenteredToast } from "../components/CenteredToast";

const SmbProcess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const iframeRef = useRef<any>(null);
  const { phone, expireDate, term } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const storedTrackId = sessionStorage.getItem("smbTrackId");
  const savedAddress = localStorage.getItem('saved_address');
  console.log(savedAddress,"saved_address")

  useEffect(() => {
    if (!phone || !expireDate || !term) {
      navigate("/smb/");
      return;
    }
  }, [phone, expireDate, term, navigate]);

  useEffect(() => {
    function handleMessage(event:any) {
      const { type, payload } = event.data || {};

      if (event.data?.type === "resize" && iframeRef.current) {
        iframeRef.current.style.height = event.data.height + "px";
      }

      if (type === "SHOW_TOAST") {
        showCenteredToast(payload.message, {
          onConfirm: () => {},
        });
        // toast(payload.message, payload.options);
      }
      if (type === "SMB_NAVIGATE") {
        sessionStorage.removeItem("smbTrackId");
        navigate(event.data.path);
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <>
      <SmbMain>
        <Header />
        <iframe
          src={`https://embed.smb.eiqshopping.com/?phone=${phone}&expireDate=${expireDate}&term=${term}&trackId=${storedTrackId}&savedAddress=${encodeURIComponent(savedAddress || '')}&utm-content=eiqshopping`}
          width="100%"
          height="100%"
          title="smb-process"
          ref={iframeRef}
          style={{ overflow: "hidden" }}
        />
      </SmbMain>
    </>
  );
};

export default SmbProcess;
